export const REMOVE_IMAGE = 'removeImage'

export default {
	REMOVE_IMAGE
}



// WEBPACK FOOTER //
// ./src/assets/js/constans.js